module.exports = __webpack_public_path__ + "img/activities-6.6ad9928f.jpg";